import { useEffect, useState } from "react";
import { baseUrl } from "../../utils/constants";
import axios from "axios";
import { FaPaperPlane, FaRegEye } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { TablePagination, Tooltip } from "@mui/material";
import TableLoader from "../loaders/TableLoader";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Progress from "../Progress";

const AddCampaigns = () => {
  const [allCampaigns, setAllCampaigns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isAppliedLoader, setIsAppliedLoader] = useState(false);
  const token = localStorage.getItem("token");
  const influencerId = useSelector(
    (store) => store?.influencer?.influencer?._id
  );
  const getCampaigns = async () => {
    try {
      const res = await axios.get(
        `${baseUrl}/all-campaigns?page=${page + 1}&limit=${rowsPerPage}`,
        {
          headers: { "auth-token": token },
        }
      );
      setAllCampaigns(res.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCampaigns();
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const notifySuccess = (message) => toast.success(message);
  const notifyError = (message) => toast.error(message);

  const applyForCampaign = async (campaignId) => {
    try {
      setIsAppliedLoader(true);
      const response = await axios.post(`${baseUrl}/apply`, {
        influencerId,
        campaignId,
        role: "admin",
      });
      notifySuccess(response.data.message);
      setIsAppliedLoader(false);
    } catch (error) {
      console.error("Error applying for campaign:", error);
      notifyError(error.response.data.message);
      setIsAppliedLoader(false);
    }
  };

  return (
    <>
      <Progress loading={isAppliedLoader} />
      <ToastContainer />
      {isLoading ? (
        <TableLoader rows={6} columns={4} />
      ) : allCampaigns?.length === 0 ? (
        <p className="no_data mt-5">There is no campaign to show</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Campaign Name</th>
              <th>Campaign Type</th>
              <th>Campaign Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {allCampaigns?.campaigns?.map((campaign) => (
              <tr key={campaign?._id}>
                <td>{campaign?.campaignName}</td>
                <td>{campaign?.campaignType}</td>
                {campaign?.campaignStatus?.toLowerCase() === "active" && (
                  <td style={{ color: "#68daaf" }}>
                    {campaign?.campaignStatus}
                  </td>
                )}
                {campaign?.campaignStatus?.toLowerCase() ===
                  "not started yet" && (
                  <td style={{ color: "#a6a6a6" }}>
                    {campaign?.campaignStatus}
                  </td>
                )}
                {campaign?.campaignStatus?.toLowerCase() === "on hold" && (
                  <td style={{ color: "#ffc107" }}>
                    {campaign?.campaignStatus}
                  </td>
                )}
                {campaign?.campaignStatus?.toLowerCase() === "completed" && (
                  <td style={{ color: "#2e7d32" }}>
                    {campaign?.campaignStatus}
                  </td>
                )}
                <td>
                  <Tooltip title="View Campaign" placement="top">
                    <Link to={`/campaign-details/${campaign?._id}`}>
                      <button className="btn btn_edit p-0">
                        <FaRegEye style={{ marginBottom: "3px" }} />
                      </button>
                    </Link>
                  </Tooltip>
                  <Tooltip title="Apply" placement="top">
                    <button
                      className="btn btn_edit p-0 ms-3"
                      onClick={() => applyForCampaign(campaign?._id)}
                    >
                      <FaPaperPlane style={{ marginBottom: "3px" }} />
                    </button>
                  </Tooltip>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {allCampaigns?.total > 10 && (
        <div className="mt-3 d-flex align-items-center justify-content-between">
          <div></div>
          <TablePagination
            component="div"
            count={allCampaigns?.total || 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      )}
    </>
  );
};

export default AddCampaigns;
